import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Modal, Button, Icon} from "antd";

@inject("dialog")
@observer
class FirstLoadTipDialog extends Component {
  handleOk = () => {
    this.props.dialog.setFirstLoadTipOpen(false);
    // 标记已经显示过提示，不再显示
    window.localStorage.setItem("FIRST_LOAD_TIP_SHOWN", "true");
  };

  handleCancel = () => {
    this.props.dialog.setFirstLoadTipOpen(false);
    // 标记已经显示过提示，不再显示
    window.localStorage.setItem("FIRST_LOAD_TIP_SHOWN", "true");
  };

  render() {
    return (
      <Modal
        title={
          <span>
            <Icon type="info-circle" style={{color: "#1890ff", marginRight: 8}} />
            温馨提示
          </span>
        }
        okText="知道了"
        cancelText="关闭"
        visible={this.props.dialog.isFirstLoadTipOpen}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" onClick={this.handleOk}>
            知道了
          </Button>,
        ]}
        bodyStyle={{
          paddingTop: "20px",
        }}
        width={500}
      >
        <div style={style.container}>
          <p style={style.text}>
            <Icon type="loading" style={{marginRight: 8, color: "#1890ff"}} />
            第一次加载编辑模块较慢，之后使用就会快。
          </p>
          <p style={style.hint}>首次加载需要下载必要的资源文件，请耐心等待。加载完成后，后续使用会更加流畅。</p>
        </div>
      </Modal>
    );
  }
}

const style = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  text: {
    fontSize: "16px",
    lineHeight: "28px",
    color: "#333",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
  },
  hint: {
    fontSize: "14px",
    lineHeight: "24px",
    color: "#666",
    marginTop: "8px",
    textAlign: "center",
  },
};

export default FirstLoadTipDialog;
